import React from 'react';
import { Icon, Tooltip } from '@upsales/components';
import moment from 'moment';
import './MailOpenClickIndicator.scss';
import bemClass from '@upsales/components/Utils/bemClass';
import { useTranslation } from 'Components/Helpers/translate';
import { Text } from '@upsales/components';
import Mail from 'App/resources/Model/Mail';
import SignalIndicators from '../SignalIndicators';

interface MailOpenClickIndicatorProps {
	mail: Mail;
	date?: string | Date | null | undefined;
	bounced?: boolean;
	showDate?: boolean;
	showSentiment?: boolean;
	expandable?: boolean;
}

const MailOpenClickIndicator: React.FC<MailOpenClickIndicatorProps> = ({
	mail,
	date,
	bounced,
	showDate,
	showSentiment,
	expandable
}: MailOpenClickIndicatorProps) => {
	const { t } = useTranslation();
	if (mail.type === 'err') {
		return <></>;
	}
	const classes = new bemClass('MailOpenClickIndicator');
	const hasRead = !!mail.lastReadDate;
	const hasClicked = !!mail.lastClickDate;
	const hasReadText = mail.lastReadDate
		? `${t('event.mailWasRead')} ${moment(mail.lastReadDate).format('YYYY-MM-DD HH:mm')}${
				expandable ? `\n${t('event.mail.clickForAll')}` : ''
		  }`
		: t('event.mailWasNotRead');
	const hasClickedText = mail.lastClickDate
		? `${t('mail.mailEvent.click')} ${moment(mail.lastClickDate).format('YYYY-MM-DD HH:mm')}${
				expandable ? `\n${t('event.mail.clickForAll')}` : ''
		  }`
		: t('event.mailNotClicked');

	const mailsInThread = mail.mailsInThreadCount;

	return date && bounced ? (
		<>
			<Text size="sm" color="grey-11">
				{`${moment(date).format('L LT')} •`}
			</Text>
			<Text space="mls" size="sm" color="red">
				{` ${mail.to}`}
			</Text>
		</>
	) : (
		<>
			<div className={classes.elem('container').b()}>
				{date && showDate && (
					<Text size="sm" color="grey-11">
						{moment(date).format('L LT')}
					</Text>
				)}
				{mailsInThread && mailsInThread > 1 && (
					<div className={classes.elem('mailsInThreadContainer').b()}>
						<Text size="sm" color="grey-11">
							{`•  ${mailsInThread} ${t('default.mails').toLowerCase()}`}
						</Text>
					</div>
				)}
				{showSentiment ? <SignalIndicators signals={mail.threadSignals} /> : null}
				<div className={classes.elem('event').b()}>
					<Tooltip title={hasReadText}>
						<Icon
							className={classes.elem('event').elem('read').mod({ hasRead }).b()}
							name={hasRead ? 'eye' : 'eye-slash'}
						/>
					</Tooltip>
					<Tooltip title={hasClickedText}>
						<Icon
							className={classes.elem('event').elem('click').mod({ hasClicked }).b()}
							name="mouse-pointer"
						/>
					</Tooltip>
				</div>
			</div>
		</>
	);
};

export default MailOpenClickIndicator;
